import { axios } from '@/lib/axios';
import { Playlist } from '@/types';

export const getPlaylist = ({ code }: { code: string }): Promise<{ data: Playlist | null }> => {
  return axios.get(`/0/playlist/code/${code}`);
};
